import { createApp } from 'vue'
import App from './App.vue'
import store from '@/store'
import router from '@/router'
import axios from 'axios'
import ClickOutside from '@/assets/ClickOutsideDirective.js'
import scrollTo from '@/assets/scrollToFooter.js'
import SimpleParallaxDirective from '@/assets/directives/SimpleParallax'

if (window.localStorage.getItem('auth_token')) {
	axios.defaults.headers.common['Authorization'] =
		'Bearer ' + window.localStorage.getItem('auth_token')
}
if (process.env.NODE_ENV === 'development') {
	axios.defaults.baseURL = 'http://localhost/api'
	store.state.base_directory = 'http://localhost/storage/'
} else {
	axios.defaults.baseURL = '/api'
	store.state.base_directory = '/storage/'
}
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*'

axios
	.get('/api/status')
	.then(res => {
		const { maintenance, permission } = res.data
		const isOnMaintenancePage = window.location.pathname === '/maintenance'

		if (maintenance && !permission && !isOnMaintenancePage) {
			// Редирект только если не уже на /maintenance
			window.location.href = '/maintenance'
		} else {
			// Всё норм — запускаем приложение
			const app = createApp(App)
			app
				.use(router)
				.use(store)
				.use(scrollTo)
				.directive('click-outside', ClickOutside)
				.directive('simple-parallax', SimpleParallaxDirective)
				.mount('#app')
		}
	})
	.catch(() => {
		// В случае ошибки, всё равно запускаем приложение
		const app = createApp(App)
		app
			.use(router)
			.use(store)
			.use(scrollTo)
			.directive('click-outside', ClickOutside)
			.directive('simple-parallax', SimpleParallaxDirective)
			.mount('#app')
	})
